import React from "react";
import { motion } from "framer-motion";

const IMG_BEDROOM = "/amme/sky-room.jpg";
const IMG_POOL = "/amme/pool-new.jpg";
const IMG_SAUNA = "/amme/bathroom-luxe.jpg";
const IMG_SPA = "/amme/spa-chimes.jpg";
const IMG_JUNGLE = "/amme/deck-view.jpg";

export const Rooms = ({ t }) => {
  const rooms = t.rooms.items;
  const images = [IMG_BEDROOM, IMG_POOL, IMG_SAUNA, IMG_SPA, IMG_JUNGLE];

  return (
    <section
      data-testid="rooms-section"
      className="relative bg-[#e7e7e5] py-32 md:py-48"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1 }}
          className="text-[11px] uppercase tracking-[0.4em] text-stone-500 mb-20 md:mb-28"
        >
          {t.rooms.label}
        </motion.p>

        <div className="space-y-24 md:space-y-32">
          {rooms.map((r, i) => {
            const reverse = i % 2 === 1;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
                className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 items-center ${
                  reverse ? "md:[&>div:first-child]:order-2" : ""
                }`}
                data-testid={`room-${i}`}
              >
                <div className="md:col-span-7">
                  <div className="aspect-[4/3] w-full overflow-hidden bg-stone-300 group">
                    <img
                      src={images[i]}
                      alt={r.title}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-[2000ms] group-hover:scale-105"
                    />
                  </div>
                </div>

                <div className="md:col-span-5">
                  <p className="font-serif italic text-stone-500 text-2xl md:text-3xl mb-6">
                    {String(i + 1).padStart(2, "0")}
                  </p>
                  <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl font-light text-stone-900 leading-[1.05] tracking-tight mb-6">
                    {r.title}
                  </h3>
                  <p className="text-stone-600 text-base md:text-lg font-light leading-[1.8] max-w-md">
                    {r.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
